import { Container } from "@themesberg/react-bootstrap";
import React, { useEffect, useState } from 'react';
import { get } from "../../services/back.service";
import ShiftWidget from "../widgets/shift";

function ListShift(){
    const [info, setInfo]=useState({
        pending: 0,
        hour_pending: 0,
        ready_deliver: 0,
        hour_ready_deliver: 0,
    })
    useEffect(()=>{
        const getInfo= async ()=>{
            const response = await get('/dashboard/currentshift/', {})
            if(response.success){
                setInfo(response.data);
            }else{
                console.log(response)
            }
        }
        getInfo();
    }, []);
    return(
        <Container>
            <ShiftWidget title={"Turnos En Peritaje"} Noshift={info.pending} time={info.hour_pending} />
            <ShiftWidget title={"Turnos Entrega Documentos"} Noshift={info.ready_deliver} time={info.hour_ready_deliver} />
        </Container>
    );
}

export default ListShift;